var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FBBC04",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1113_100846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11H8C7.86739 11 7.74021 11.0527 7.64645 11.1464C7.55268 11.2402 7.5 11.3674 7.5 11.5C7.5 11.6326 7.55268 11.7598 7.64645 11.8536C7.74021 11.9473 7.86739 12 8 12H8.5V19C8.5 19.1326 8.55268 19.2598 8.64645 19.3536C8.74021 19.4473 8.86739 19.5 9 19.5C9.13261 19.5 9.25979 19.4473 9.35355 19.3536C9.44732 19.2598 9.5 19.1326 9.5 19V16H21.5V19C21.5 19.1326 21.5527 19.2598 21.6464 19.3536C21.7402 19.4473 21.8674 19.5 22 19.5C22.1326 19.5 22.2598 19.4473 22.3536 19.3536C22.4473 19.2598 22.5 19.1326 22.5 19V12H23C23.1326 12 23.2598 11.9473 23.3536 11.8536C23.4473 11.7598 23.5 11.6326 23.5 11.5C23.5 11.3674 23.4473 11.2402 23.3536 11.1464C23.2598 11.0527 23.1326 11 23 11ZM9.5 12H15V15H9.5V12ZM21.5 15H16V12H21.5V15ZM13.5 13.5C13.5 13.6326 13.4473 13.7598 13.3536 13.8536C13.2598 13.9473 13.1326 14 13 14H11.5C11.3674 14 11.2402 13.9473 11.1464 13.8536C11.0527 13.7598 11 13.6326 11 13.5C11 13.3674 11.0527 13.2402 11.1464 13.1464C11.2402 13.0527 11.3674 13 11.5 13H13C13.1326 13 13.2598 13.0527 13.3536 13.1464C13.4473 13.2402 13.5 13.3674 13.5 13.5ZM17.5 13.5C17.5 13.3674 17.5527 13.2402 17.6464 13.1464C17.7402 13.0527 17.8674 13 18 13H19.5C19.6326 13 19.7598 13.0527 19.8536 13.1464C19.9473 13.2402 20 13.3674 20 13.5C20 13.6326 19.9473 13.7598 19.8536 13.8536C19.7598 13.9473 19.6326 14 19.5 14H18C17.8674 14 17.7402 13.9473 17.6464 13.8536C17.5527 13.7598 17.5 13.6326 17.5 13.5Z",
    fill: "#FBBC04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1113_100846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/Office.c261f4e919e8ab8eef25eb9e2b87d54b.svg";
export { ForwardRef as ReactComponent };